/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectCollisionSystem} from "./searchObjects"



export function fillSearchObjectCollisionSystem(){
    searchObjectCollisionSystem.categories = [];
    searchObjectCollisionSystem.keywords = [];

    const checkbox = document.getElementById("categoryCollisionSystem");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectCollisionSystem.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonCollisionSystemAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectCollisionSystem.any = true;
    }

    const allButton = document.getElementById("buttonCollisionSystemAll");
    if(allButton.classList.contains("chosen")){
        searchObjectCollisionSystem.any = false;
    }
    
    const buttonpP = document.getElementById("buttonCollisionSystempP");
    if(buttonpP.classList.contains('selected')){
        searchObjectCollisionSystem.keywords.push(buttonpP.value)
    }
    
    const buttonOtherInclCosmicRays = document.getElementById("buttonCollisionSystemOtherInclCosmicRays");
    if(buttonOtherInclCosmicRays.classList.contains('selected')){
        searchObjectCollisionSystem.keywords.push(buttonOtherInclCosmicRays.value)
    }
    
    const buttonPbPb = document.getElementById("buttonCollisionSystemPbPb");
    if(buttonPbPb.classList.contains('selected')){
        searchObjectCollisionSystem.keywords.push(buttonPbPb.value)
    }
    
    const buttonpPb = document.getElementById("buttonCollisionSystempPb");
    if(buttonpPb.classList.contains('selected')){
        searchObjectCollisionSystem.keywords.push(buttonpPb.value)
    }
    
    const buttonXeXe = document.getElementById("buttonCollisionSystemXeXe");
    if(buttonXeXe.classList.contains('selected')){
        searchObjectCollisionSystem.keywords.push(buttonXeXe.value)
    }
    
    getAllFiltered()

}